// extracted by mini-css-extract-plugin
export default {"icon":"Icons_icon__Bv4Cx","container":"Icons_container__dQx3t"};